import React from 'react';
import { Box, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import logo from './green_logo.png';

export default function Header({ userId }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        mb: 2,
      }}
    >
      <Box
        component={RouterLink}
        to={`/${userId}`}
        sx={{ display: 'flex', alignItems: 'center' }}
      >
        <Box component="img" src={logo} alt="Logo" sx={{ height: 50 }} />
      </Box>
      
      {userId && (
        <Box>
          <Button
            component={RouterLink}
            to={`/account/${userId}`}
            variant="outlined"
            sx={{ 
              mr: 1,
              color: '#36b63f',
              borderColor: '#36b63f',
              fontWeight: 600,
              textTransform: 'none',
              '&:hover': {
                borderColor: '#36b63f',
                backgroundColor: 'rgba(54, 182, 63, 0.04)'
              }
            }}
          >
            FAQs
          </Button>
        </Box>
      )}
    </Box>
  );
}